
import {configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
import jobListReducer from './reducers/JobListReducer'

// store for recipe list 
const createStore = () => {
    return configureStore({
        reducer: {
            jobListReducer
        },
        middleware: [thunk]
    })
}

export default createStore